import AddInsurancechannelInfoModal from './add-insurancechannel-info-modal.vue'
export default AddInsurancechannelInfoModal
